import request from '@/utils/http'

export interface ActiveTimeReportPayload {
  date: string
  clientDayId: string
  clientAccumulatedSeconds: number
}

export interface ActiveTimeReportVo {
  date: string
  activeSeconds: number
  truncated: boolean
  continueReport: boolean
}

/**
 * 网页停留时间上报
 */
export const reportActiveTimeApi = (payload: ActiveTimeReportPayload) => {
  return request.post<ActiveTimeReportVo>('/api/study/active-time/report', payload)
}
